import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { PaymentSources, SetColorsService } from 'core'

@Component({
  selector: 'bmprod-checkout-page',
  templateUrl: './bmprod-checkout-page.component.html',
  styleUrls: ['./bmprod-checkout-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmprodCheckoutPageComponent implements OnInit {
  paymentSource = PaymentSources.ProducerPage
  colorSettingsMode = false

  constructor(private setColorsService: SetColorsService) {}

  ngOnInit(): void {
    this.getColorSettingsMode()
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
